import { Injectable } from "@angular/core";
import { ConfigService } from "../config/config.service";
import { UtilsService } from "../utils/utils.service";

@Injectable({
    providedIn: "root",
})
export class GeoLocationStrategyService {
    constructor(
        private configService: ConfigService,
        private utilsService: UtilsService
    ) { }

    isGeoOptimizationEnabled(): boolean {
        const platform = this.utilsService.getPlatformInfo();
        const isGlobalEnabled = this.isFeatureEnabled("FEATURE_GEOLOCATION_GEOCOMPLY_USE_OPTIMIZED_CODE");

        if (!isGlobalEnabled) {
            return false;
        }

        const isOptimized =
            (platform.isIosApp && this.isFeatureEnabled("FEATURE_GEOLOCATION_GEOCOMPLY_USE_OPTIMIZED_CODE_IOS_APP")) ||
            (platform.isAndroidApp && this.isFeatureEnabled("FEATURE_GEOLOCATION_GEOCOMPLY_USE_OPTIMIZED_CODE_ANDROID_APP")) ||
            (platform.isDesktopWeb && this.isFeatureEnabled("FEATURE_GEOLOCATION_GEOCOMPLY_USE_OPTIMIZED_CODE_DESKTOP_WEB")) ||
            (platform.isMobileWeb && this.isFeatureEnabled("FEATURE_GEOLOCATION_GEOCOMPLY_USE_OPTIMIZED_CODE_MOBILE_WEB"));
        return isOptimized;
    }

    private isFeatureEnabled(featureFlag: string): boolean {
        const value = this.configService.getConfig()[featureFlag];
        return value === "1" ? true : false;
    }

    //helper function for UI visiblity for QA
    getGeoOptimizationStatus(): Record<string, boolean> {
        return {
          DesktopWeb: this.isFeatureEnabled("FEATURE_GEOLOCATION_GEOCOMPLY_USE_OPTIMIZED_CODE_DESKTOP_WEB"),
          MobileWeb: this.isFeatureEnabled("FEATURE_GEOLOCATION_GEOCOMPLY_USE_OPTIMIZED_CODE_MOBILE_WEB"),
          iOSApp: this.isFeatureEnabled("FEATURE_GEOLOCATION_GEOCOMPLY_USE_OPTIMIZED_CODE_IOS_APP"),
          AndroidApp: this.isFeatureEnabled("FEATURE_GEOLOCATION_GEOCOMPLY_USE_OPTIMIZED_CODE_ANDROID_APP"),
        };
      }
}